module.exports = __webpack_public_path__ + "img/nuevo-swift-boostergreen.d8db758f.png";